import axios from '../../index'
import qs from 'qs'
/**
 * @description 分销商我的订单
 * @author txw
 * @date 2019-12-10
 * @export
 *
 */
export function loadDistributorOrder (params) {
  return axios.post(`/user/distributor-order`, qs.stringify(params))
}
/**
 * @description 修改订单状态
 * @author txw
 * @date 2019-12-10
 * @export
 *
 */
export function editOrderState (params) {
  return axios.post(`/user/modify-order-cate-state`, qs.stringify(params))
}
/**
 * @description 订单详情
 * @author txw
 * @date 2019-12-11
 * @export
 *
 */
export function loadOrderDetail (params) {
  return axios.post(`/user/distributor-order-details`, qs.stringify(params))
}
/**
 * @description 改价
 * http://192.168.2.177:3000/project/11/interface/api/1588
 * @author txw
 * @date 2019-12-19
 * @export
 * @param {*} params
 * @returns
 */
export function modifyPrice (params) {
  return axios.post('/user/modify-price', qs.stringify(params))
}
